import { TagManager } from '../../../../trillion-common/src/tag-manager/TagManager'
import { ViteEnvString } from '../types/vite-env'
import { ViewerBaseGTMEvent, ViewerGTMEvents } from './viewer-gtm-events'

function gtmEventProducer() {
  const producedEvents = new Set<keyof typeof ViewerGTMEvents>()
  const dataLayerName = import.meta.env.VITE_GTM_DATA_LAYER_NAME as ViteEnvString

  return function <T extends ViewerBaseGTMEvent>(payload: T, once?: boolean) {
    if ((!once || !producedEvents.has(payload.event)) && dataLayerName) {
      producedEvents.add(payload.event)
      TagManager.send(payload, dataLayerName)
    }
  }
}

export const produceGtmEvent = gtmEventProducer()
